import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { OverflowDetector } from 'react-overflow';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

import styles from './styles';

const OverflowTooltipText = ({ classes, children }) => {
    const [isOverflowed, setIsOverflowed] = useState(false);
    const [open, setOpen] = useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    const updateisOverflowed = (newIsOverflowed) => {
        if (newIsOverflowed !== isOverflowed) setIsOverflowed(newIsOverflowed);
    };

    return (
        <Tooltip
            open={open}
            title={isOverflowed ? children : ''}
            classes={{ tooltip: classes.tooltip }}
            data-testid="tooltip"
        >
            <OverflowDetector className={classes.text} onOverflowChange={updateisOverflowed}>
                <span
                    onMouseOver={handleTooltipOpen}
                    onMouseLeave={handleTooltipClose}
                    data-testid="tooltip-span"
                >
                    {children}
                </span>
            </OverflowDetector>
        </Tooltip>
    );
};

OverflowTooltipText.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
};

export { OverflowTooltipText as OverflowTooltipTextAlias };

export default withStyles(styles)(OverflowTooltipText);
